import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { updateOfferProduct } from "../../../api/offerProduct";
import { alertError, alertSuccess } from "../../../utils/logger";
import LoadingDialog from "./LoadingDialog";

const ChangeOfferProductMultiplicableDialog = (props) => {
  const { title, open, setOpen, data, onSave } = props;

  const [loading, setLoading] = React.useState(false);

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  const nextMultiplicableValue = !(data?.multiplicable ?? true);

  function handleClose() {
    setOpen(false);
  }

  function saveMultiplicable() {
    setLoading(true);

    updateOfferProduct(
      data?.producto_id,
      {
        ...data,
        multiplicable: nextMultiplicableValue,
      },
      loggedUser?.accessToken
    )
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          alertSuccess({
            title: "Guardado",
            customMessage: "Multiplicable actualizado con exito",
          });
          if (typeof onSave === "function") {
            onSave(res.data);
          }
          handleClose();
        }
      })
      .catch((error) => {
        alertError({
          error,
          customMessage: "No se ha podido actualizar el campo multiplicable",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="xs"
        open={open}
        onClose={handleClose}
        aria-labelledby="change-offer-product-multiplicable-dialog"
        className="backdrop"
      >
        <DialogTitle id="change-offer-product-multiplicable-dialog">
          {title || "Cambiar multiplicable"}
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Producto"
            value={data?.descripcion ?? ""}
            InputLabelProps={{ shrink: true }}
            InputProps={{ readOnly: true }}
            margin="normal"
            variant="outlined"
          />
          <div style={{ marginTop: 12, marginBottom: 8 }}>
            {nextMultiplicableValue
              ? "¿Quieres marcar este producto como multiplicable?"
              : "¿Quieres marcar este producto como no multiplicable?"}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            Cancelar
          </Button>
          <Button onClick={saveMultiplicable} variant="outlined" color="primary">
            Actualizar
          </Button>
        </DialogActions>
      </Dialog>
      <LoadingDialog open={loading} />
    </>
  );
};

export default ChangeOfferProductMultiplicableDialog;
